import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Redirect, withRouter } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => {
    //if userAgent is from Google or ReactSnap
    //Bypass age gate, return Component directly. 
    if(
        navigator.userAgent.indexOf('ReactSnap') >= 0 
    ||  navigator.userAgent.indexOf('APIs-Google') >= 0 
    ||  navigator.userAgent.indexOf('Mediapartners-Google') >= 0 
    ||  navigator.userAgent.indexOf('AdsBot-Google-Mobile') >= 0 
    ||  navigator.userAgent.indexOf('AdsBot-Google-Mobile') >= 0 
    ||  navigator.userAgent.indexOf('AdsBot-Google') >= 0 
    ||  navigator.userAgent.indexOf('Googlebot') >= 0 
    ||  navigator.userAgent.indexOf('Mediapartners-Google') >= 0 
    ||  navigator.userAgent.indexOf('AdsBot-Google-Mobile-Apps') >= 0 
    ){
        return(<Route  render={() => (<Component match={rest.computedMatch} {...rest}></Component>)}/>)
    }
    let routePart;
    const lsObj = JSON.parse(localStorage.getItem('altavie_agegate'));
    const seObj = JSON.parse(sessionStorage.getItem('altavie_agegate'));
    if((lsObj && Date.now() < lsObj.expiresAt) || seObj){
        routePart = <Component match={rest.computedMatch} {...rest}></Component>
    }else{
        routePart = <Redirect to={{
                                    pathname: "/age-gate",
                                    search: rest.location.search ? rest.location.search : '',
                                    state: { from: rest.location }
                                }}/>
    }
    return(<Route  render={() => (routePart)}/>)
};

const mapStateToProps = (state) => {
    return{
        routing: state.routing
    }
}

export default withRouter(connect(mapStateToProps)(PrivateRoute))


// WEBPACK FOOTER //
// ./src/router/privateRoute.js